/**
 * Sparkline chart component using Recharts.
 */

import { LineChart, Line, ResponsiveContainer } from 'recharts';
import './spark-line.scss';

export interface SparkLineData {
  t: string;
  value: number;
}

export interface SparkLineProps {
  data: SparkLineData[];
  color?: string;
  height?: number;
}

export function SparkLine({ data, color = '#2196F3', height = 40 }: SparkLineProps) {
  if (!data || data.length === 0) {
    return (
      <div className="spark-line__empty">
        No data
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data}>
        <Line
          type="monotone"
          dataKey="value"
          stroke={color}
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

